import { Button } from '../Button/Button';
import { useDevice } from 'lib/hooks/useDevice';
import { useLocation } from 'react-router-dom';
import { stagePathConfig } from 'data/stage';
import { Image } from 'components/Image/Image';
import { useSessionLockStatus } from '@/lib/react-query/Queries/useSessionLockStatus';
import { useCreatorHostedSession } from 'lib/hooks/useCreatorHostedSession';

type Props = {
  openChangeDateModal: () => void;
};

const ChangeDate = ({ openChangeDateModal }: Props) => {
  const { isLocked, isLoading } = useSessionLockStatus();
  const { isCreatorHosted } = useCreatorHostedSession();
  const clickHandler = () => openChangeDateModal();
  const { isMobile, isDesktop } = useDevice();
  const location = useLocation();
  const isDisabled =
    location.pathname === stagePathConfig.payment ||
    location.pathname === stagePathConfig.paymentProcessing ||
    location.pathname === stagePathConfig.transactionFailed;

  // Creator-hosted sessions keep the creator's departure date.
  if (isLocked || isLoading || isCreatorHosted) {
    return null;
  }

  return (
    <div className="block">
      <Button
        text={isDesktop ? 'Change Date' : ''}
        size="extra-small"
        type="secondary-border"
        icon={
          isMobile ? (
            <Image path="booking/icons/calendar.svg" alt="calendar icon" />
          ) : undefined
        }
        clickHandler={clickHandler}
        className={isMobile ? ' !border-dark-500' : ''}
        isDisabled={isDisabled || isLoading || isLocked}
        disabledTooltip={"You can't change date in this stage"}
      />
    </div>
  );
};

export { ChangeDate };
